import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Search, SlidersHorizontal, IndianRupee } from 'lucide-react';
import { toursData } from '../data/tours';
import TourCard from '../components/TourCard';
import './ToursListing.css';

export default function DomesticTours() {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParamQuery = searchParams.get('search') || '';

  const [searchQuery, setSearchQuery] = useState(searchParamQuery);
  const [maxPrice, setMaxPrice] = useState(40000);
  const [filteredTours, setFilteredTours] = useState([]);

  const domesticTours = toursData.filter((t) => t.category === 'Domestic');

  useEffect(() => {
    setSearchQuery(searchParamQuery);
  }, [searchParamQuery]);

  useEffect(() => {
    const filtered = toursData
      .filter((t) => t.category === 'Domestic')
      .filter((tour) => {
        const matchesSearch = tour.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
                              tour.shortDescription.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesPrice = tour.price <= maxPrice;
        return matchesSearch && matchesPrice;
      });
    setFilteredTours(filtered);
  }, [searchQuery, maxPrice]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    setSearchParams(value ? { search: value } : {});
  };

  const clearFilters = () => {
    setSearchQuery('');
    setMaxPrice(40000);
    setSearchParams({});
  };

  return (
    <div className="tours-listing-page container section">
      <div className="section-title">
        <h2>Domestic Tour Packages</h2>
        <p>Explore the diverse landscapes, rich cultures, and serene retreats across India.</p>
      </div>

      {/* Filter and Search Bar */}
      <div className="listing-controls glass-card">
        <div className="search-box">
          <Search size={18} className="search-icon" />
          <input
            type="text"
            className="form-control"
            placeholder="Search domestic destinations..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>

        <div className="price-filter">
          <div className="filter-header">
            <div className="filter-label">
              <SlidersHorizontal size={16} />
              <span>Max Budget:</span>
            </div>
            <span className="price-value">₹{maxPrice.toLocaleString('en-IN')}</span>
          </div>
          <input
            type="range"
            min="20000"
            max="40000"
            step="1000"
            value={maxPrice}
            onChange={(e) => setMaxPrice(Number(e.target.value))}
            className="price-slider"
          />
        </div>

        {(searchQuery || maxPrice < 40000) && (
          <button className="btn btn-secondary clear-filters-btn" onClick={clearFilters}>
            Reset Filters
          </button>
        )}
      </div>

      {/* Results Info */}
      <div className="results-info">
        <p>Showing <strong>{filteredTours.length}</strong> of <strong>{domesticTours.length}</strong> domestic packages</p>
      </div>

      {/* Tours Grid */}
      {filteredTours.length > 0 ? (
        <div className="grid grid-3 tours-grid">
          {filteredTours.map((tour) => (
            <TourCard key={tour.id} tour={tour} />
          ))}
        </div>
      ) : (
        <div className="no-results glass-card">
          <IndianRupee size={48} className="no-results-icon" />
          <h3>No Packages Found</h3>
          <p>We couldn't find any domestic tours matching your search criteria. Try adjusting your price range or search terms.</p>
          <button className="btn btn-primary" onClick={clearFilters}>
            Show All Domestic Tours
          </button>
        </div>
      )}
    </div>
  );
}
